import Hls from "hls.js"

const updateStatus = (element, text, tone = "neutral") => {
  if (!element) return

  element.textContent = text
  element.dataset.tone = tone
}

const mountNodeLiveView = async (element) => {
  if (!element || element.dataset.liveViewMounted === "true") return
  element.dataset.liveViewMounted = "true"

  const status = element.querySelector("[data-node-live-view-status]")
  const video = element.querySelector("[data-node-live-view-video]")
  const image = element.querySelector("[data-node-live-view-image]")
  const empty = element.querySelector("[data-node-live-view-empty]")
  const openButton = element.querySelector("[data-node-live-view-open]")
  const hlsButton = element.querySelector("[data-node-live-view-hls]")

  const streamUrl = element.dataset.streamUrl || ""
  const fallbackStreamUrl = element.dataset.fallbackStreamUrl || ""
  const hlsUrl = element.dataset.hlsUrl || ""
  const multipartUrl = streamUrl || fallbackStreamUrl

  if (openButton && fallbackStreamUrl) {
    openButton.href = fallbackStreamUrl
    openButton.hidden = false
  }

  if (hlsButton && hlsUrl) {
    hlsButton.href = hlsUrl
    hlsButton.hidden = false
  }

  const startMultipartPreview = () => {
    if (!image || !multipartUrl) return false

    updateStatus(status, "Connecting multipart live stream…", "working")
    image.onload = () => {
      image.hidden = false
      if (video) video.hidden = true
      if (empty) empty.hidden = true
      updateStatus(status, "Live stream connected.", "success")
    }
    image.onerror = () => {
      image.hidden = true
      if (empty) {
        empty.hidden = false
        empty.textContent = "The inline live preview could not be started."
      }
      updateStatus(status, "Inline live preview could not be loaded.", "error")
    }
    image.src = multipartUrl
    return true
  }

  try {
    if (video && hlsUrl) {
      updateStatus(status, "Connecting HLS live stream…", "working")

      video.muted = true
      video.playsInline = true
      video.autoplay = true

      video.onloadeddata = () => {
        video.hidden = false
        if (image) image.hidden = true
        if (empty) empty.hidden = true
        updateStatus(status, "Live stream connected.", "success")
      }
      video.onerror = () => {
        if (!startMultipartPreview() && empty) {
          empty.hidden = false
          empty.textContent = "The inline live preview could not be started."
        }
        if (!multipartUrl) updateStatus(status, "Inline live preview could not be loaded.", "error")
      }

      if (Hls.isSupported()) {
        const hls = new Hls({
          enableWorker: true,
          lowLatencyMode: true
        })
        hls.attachMedia(video)
        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          hls.loadSource(hlsUrl)
        })
        hls.on(Hls.Events.ERROR, (_event, data) => {
          if (data?.fatal) {
            hls.destroy()
            if (video) {
              video.pause()
              video.removeAttribute("src")
              video.load()
              video.hidden = true
            }
            if (!startMultipartPreview() && empty) {
              empty.hidden = false
              empty.textContent = "The inline live preview could not be started."
            }
            if (!multipartUrl) updateStatus(status, "Inline live preview could not be loaded.", "error")
          }
        })
      } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
        video.src = hlsUrl
      } else if (!startMultipartPreview()) {
        throw new Error("This browser cannot play the live stream inline.")
      }

      return
    }

    if (!multipartUrl) {
      throw new Error("No Eagle Eye live stream URL is available for this camera.")
    }

    startMultipartPreview()
  } catch (error) {
    if (empty) {
      empty.hidden = false
      empty.textContent = error.message || "Could not prepare the live view."
    }
    updateStatus(status, error.message || "Could not prepare the live view.", "error")
  }
}

const mountNodeLiveViews = () => {
  document.querySelectorAll("[data-node-live-view]").forEach((element) => {
    mountNodeLiveView(element)
  })
}

export { mountNodeLiveViews }
